import OneSignal from "react-onesignal";

let initializePromise = null;

export function isOneSignalAvailable() {
  return Boolean(process.env.REACT_APP_ONESIGNAL_APP_ID);
}

export async function initializeOneSignal() {
  const appId = process.env.REACT_APP_ONESIGNAL_APP_ID;
  if (!appId) {
    return false;
  }
  if (!initializePromise) {
    initializePromise = OneSignal.init({
      appId,
      notifyButton: { enable: false },
    }).catch((error) => {
      initializePromise = null;
      throw error;
    });
  }
  await initializePromise;
  return true;
}

export { OneSignal };